interface RosterPlayer {
  id: string;
  name: string;
  player_key?: string;
}

interface Props {
  roster: RosterPlayer[];
  teamMode: 'auto' | 'manual';
  onTeamModeChange: (mode: 'auto' | 'manual') => void;
  manualTeams: Record<string, number>;
  onManualTeamChange: (playerId: string, teamIndex: number) => void;
}

export function RoundTeamsSetupPanel({
  roster,
  teamMode,
  onTeamModeChange,
  manualTeams,
  onManualTeamChange,
}: Props) {
  return (
    <div className="space-y-4">
      <p className="text-xs leading-relaxed text-ink-soft">
        Team formats need two sides. With 3 players, one team has two and the other has one.
      </p>
      <div className="flex gap-2">
        {(['auto', 'manual'] as const).map((mode) => (
          <button
            key={mode}
            type="button"
            onClick={() => onTeamModeChange(mode)}
            className={`flex-1 rounded-lg py-2.5 text-xs font-bold ${
              teamMode === mode ? 'bg-navy text-cream' : 'border border-line bg-paper'
            }`}
          >
            {mode === 'auto' ? 'Auto Generate' : 'Manual Teams'}
          </button>
        ))}
      </div>
      {teamMode === 'manual' && roster.map((p, i) => (
        <div key={p.id} className="flex items-center justify-between rounded-lg border border-line px-3 py-2">
          <span className="text-sm font-semibold">{p.name}</span>
          <div className="flex gap-1">
            {['A', 'B'].map((t, ix) => (
              <button
                key={t}
                type="button"
                onClick={() => onManualTeamChange(p.id, ix)}
                className={`rounded-full px-3 py-1 text-xs font-bold ${
                  (manualTeams[p.id] ?? (i < 2 ? 0 : 1)) === ix ? 'bg-navy text-cream' : 'bg-line text-ink-soft'
                }`}
              >
                Team {t}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function buildTeamsFromSetup(
  roster: RosterPlayer[],
  playerKeys: string[],
  teamMode: 'auto' | 'manual',
  manualTeams: Record<string, number>,
  autoTeamsFn: (keys: string[]) => string[][],
): string[][] {
  if (teamMode === 'auto') return autoTeamsFn(playerKeys);
  return [
    playerKeys.filter((_, i) => (manualTeams[roster[i].id] ?? (i < 2 ? 0 : 1)) === 0),
    playerKeys.filter((_, i) => (manualTeams[roster[i].id] ?? (i < 2 ? 0 : 1)) === 1),
  ];
}
